import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Drawer } from "antd";

import {
  HeaderSection,
  LogoContainer,
  Burger,
  NavLinks,
  StyledButton,
  MobileDropdown,
  MobileDropdownItem,
  DrawerHeader,
  CloseIcon,
} from "./styles";

import logo1 from "../../assets/Fact2news-logo.png";

/* ================= CATEGORY ================= */

const categories = ["Politics", "Technology", "Agriculture", "Sports", "Social"];

const Header = () => {
  const navigate = useNavigate();
  const [visible, setVisibility] = useState(false);

  const navigateToCategory = (cat: string) => {
    navigate(`/news/${cat.toLowerCase()}`);
    setVisibility(false);
  };

  return (
    <HeaderSection>
      {/* LOGO */}
      <LogoContainer to="/">
        <img src={logo1} alt="logo" />
      </LogoContainer>

      {/* BURGER */}
      <Burger onClick={() => setVisibility(true)}>
        <div />
        <div />
        <div />
      </Burger>

      {/* ================= DESKTOP ================= */}

      <NavLinks>
        <div style={{ display: "flex", gap: "10px" }}>
          {categories.map((cat) => (
            <StyledButton
              key={cat}
              onClick={() => navigateToCategory(cat)}
              style={{
                fontWeight: 600,
                fontSize: "14px",
                letterSpacing: "0.5px",
              }}
            >
              {cat}
            </StyledButton>
          ))}
        </div>
      </NavLinks>

      {/* ================= MOBILE ================= */}

      <Drawer open={visible} placement="right" closable={false} width={280}>
        <DrawerHeader>
          <CloseIcon onClick={() => setVisibility(false)}>✕</CloseIcon>
        </DrawerHeader>

        <MobileDropdown>
          {categories.map((cat) => (
            <MobileDropdownItem
              key={cat}
              onClick={() => navigateToCategory(cat)}
            >
              {cat}
            </MobileDropdownItem>
          ))}
        </MobileDropdown>
      </Drawer>
    </HeaderSection>
  );
};

export default Header;